export const labels = {
  companyName: 'Company name',
  companyRegNo: 'Company reg. no.:',
  companyVatNo: 'VAT reg. no.:',
  provider: 'Provider',
  customer: 'Customer',
  invoice: 'Penjualan',
  invoiceDate: 'Tanggal',
  invoiceNumber: 'Nomor Bon.',
  invoiceSeries: 'Invoice series',
  worksCompleted: 'Bon Penjualan',
  date: 'Date',
  description: 'Nama Barang',
  qty: 'Qty',
  unit: 'Unit',
  rate: 'Harga',
  total: 'Total',
  vatBasis: 'VAT Basis',
  vatAmount: 'VAT Amount',
  vatRate: 'VAT rate',
  vatRatePct: 'VAT rate %',
  currency: 'Currency',
  vat: 'VAT',
  totalPayable: 'Total Payable',
  addNew: 'Add new row',
  invoiceMeta: 'Invoice meta',
  invoiceBranding: 'CUSTOMER',
  companyId: 'Company ID',
  enterEntryDescription: 'Entry description',
  billingInformation: 'Billing information',
  billingBankAccountIban: 'Pedagang:',
  billingBankAccountBic: 'Agen:',
  billingBankAccountNo: 'Account number:',
  billingBankAccountSortCode: 'Sort code:',
  name: 'Name',
  brandName: 'Agen',
  brandSubName: 'Pedagang',
  role: 'Role',
  addressLine1: 'Address Line 1',
  addressLine2: 'Address Line 2',
  addressLine3: 'Address Line 3',
  addressLine4: 'Address Line 4',

  // other interface translations
  dateFormat: 'DD/MM/YYYY',
  // show: 'Show',
  // hide: 'Hide',
  showForm: 'Show form',
  hideForm: 'Hide form',
  note: 'Note',
  createNewInvoice: 'Create new invoice',
  creatingNewInvoice: 'Creating new invoice',
  editingExistingInvoice: 'Editing existing invoice',
  saveInvoice: 'Save invoice',
  lock: 'Lock',
  unlock: 'Unlock',
  deleteInvoice: 'Delete invoice',
  companyDetails: 'Company details',
  representativeDetails: 'Representative details',
  companyAddress: 'Company address',
  billingInfo: 'Billing info',
  isClientVatRegistered: 'Is client VAT registered?',
  prefillCustomer: 'Prefill',
  selectExistingCustomer: 'Select from existing customers',
  showingCustomersWithDetails: 'Showing customers that have "Address Line 1" present.',
}
